<div class="login">
    <form class="k-form" [formGroup]="form">
      <fieldset class="k-form-fieldset">
        <img src="assets/world-top-docs.png" class="login-logo">
        <kendo-formfield>
  
          <kendo-textbox
            formControlName="email"
            placeholder="Email"
            #email
            required
          >
          <ng-template kendoTextBoxSuffixTemplate>
            <img src="assets/username.svg" style="margin-right: 5px;">
          </ng-template>
        </kendo-textbox>
  
          <kendo-formerror>Error: Email is required</kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-textbox
            formControlName="password"
            placeholder="Password"
            #password
            required
          >
          <ng-template kendoTextBoxSuffixTemplate>
            <img src="assets/eye_v2.svg" (click)="toggleVisibility()" style="width:25px; margin-right: 5px;">
          </ng-template>
          </kendo-textbox>
  
          <kendo-formerror>Error: Password is required</kendo-formerror>
        </kendo-formfield>
  
        <div class="k-form-buttons">
          <button class="k-button k-primary btn-white" (click)="submit()">Login</button>
        </div>
      </fieldset>
    </form>
  </div>